"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs } from "react/jsx-runtime";
import React from "react";
import Auth from "../util/auth";
class BeamerUpdates extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { messageCount: 0 });
    __publicField(this, "handleClickBeamer", () => {
      if (typeof Beamer !== "undefined") {
        Beamer.show();
        this.setState({ messageCount: 0 });
      }
    });
    __publicField(this, "handleInitBeamer", () => {
      var _a;
      const user = Auth.getCurrentUser();
      if (user && user.account && typeof Beamer !== "undefined") {
        const isFactorAccount = user.account.factor_account;
        const isNextGenAudit = ((_a = user.account.settings) == null ? void 0 : _a.next_gen_audit) || false;
        const config = {
          callback: this.handleSetMessageCount,
          filter: (isFactorAccount ? "factor" : "broker") + ";payables",
          user_email: user.email,
          user_id: user.id,
          next_gen_audit: isNextGenAudit
        };
        Beamer.update(config);
        Beamer.init();
      }
    });
    __publicField(this, "handleSetMessageCount", (messageCount) => {
      this.setState({ messageCount });
    });
  }
  componentDidMount() {
    this.handleInitBeamer();
  }
  render() {
    const { messageCount } = this.state;
    return /* @__PURE__ */ jsxs("a", { "data-component": "BeamerUpdates", onClick: this.handleClickBeamer, children: [
      "Updates",
      messageCount ? ` (${messageCount})` : ""
    ] });
  }
}
export default BeamerUpdates;
